import api from "../../Api/feathers-client";
import { findIndex, maxBy } from "lodash";

// Call backend service to authenticate
export const getAssignmentData = async (obj) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("get-assignment-by-status").find({
        query: {
          assignmentName: "",
          created_by: obj.createdBy,
          learners: {
            $contains: {
              learners: [obj.userId],
            },
          },
          isSelfLearn: obj.isSelfLearn,
          filter_by: obj.filterBy,
          user_type: obj.userType,
          learnerId: obj.userId,
          site_uuid: obj.site_uuid,
          totalData: obj.totalData,
          $skip: obj.skip,
          $limit: obj.limit,
          $sort: {
            createdAt: obj.order,
          },
        },
      });

      resolve({
        status: 200,
        message: "Assignment Data",
        data: response,
      });
    } catch (error) {
      resolve(error);
    }
  });
};

// Call backend service to get tasks of assignment
export const getTasksData = async (tasksUid, site_uuid) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("tasks").find({
        query: {
          uid: tasksUid,
          site_uuid: site_uuid,
        },
      });

      resolve({
        status: 200,
        message: "Task Data",
        data: response.data,
      });
    } catch (error) {
      resolve(error);
    }
  });
};

// Call backend service to get resume assignment
export const getResumeAssignmentData = async (
  assignmentUid,
  userId,
  site_uuid
) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("user-logs").find({
        query: {
          verb: "attemptAssignment",
          target: assignmentUid,
          actor: userId,
          $limit: 1,
          $sort: {
            id: -1,
          },
          site_uuid: site_uuid,
        },
      });

      resolve({
        status: 200,
        message: "Task Data",
        data: response.data,
      });
    } catch (error) {
      resolve(error);
    }
  });
};

export const getAllAssets = async (asset_ids, site_uuid) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("assets").find({
        query: {
          asset_uid: {
            $in: asset_ids,
          },
          site_uuid: site_uuid,
          $limit: 500,
        },
      });

      resolve({
        status: 200,
        message: "All Task",
        data: response["data"],
      });
    } catch (error) {
      resolve(error);
    }
  });
};

export const insertSummaryLog = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api
        .service("assignment-summary-logs")
        .create(data, {});

      resolve({
        status: 200,
        message: "Summary Created",
        data: response,
      });
    } catch (error) {
      resolve(error);
    }
  });
};

export const updateSummaryLog = async (id, data, actor, target, site_uuid) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api
        .service("assignment-summary-logs")
        .patch(id, data, {
          query: {
            actor,
            target,
            site_uuid,
          },
        });

      resolve({
        status: 200,
        message: "Summary Updated",
        data: response,
      });
    } catch (error) {
      resolve(error);
    }
  });
};

export const getSummaryLog = async (actor, target, site_uuid) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("assignment-summary-logs").find({
        query: {
          $select: ["id", "outcome"],
          target: target,
          actor: actor,
          site_uuid: site_uuid,
          $sort: {
            created_at: -1,
          },
          $limit: 1,
        },
      });

      resolve({
        status: 200,
        message: "Summary Logs",
        data: response,
      });
    } catch (error) {
      resolve(error);
    }
  });
};

export const UpsertSummaryLog = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      let logExist = await getSummaryLog(
        data.actor,
        data.target,
        data.site_uuid
      );

      let response;
      if (
        logExist?.data?.data?.length == 0 ||
        (data.selfLearn &&
          logExist.data.data[0]["outcome"]["attemptedAssets"] > 0 &&
          logExist.data.data[0]["outcome"]["attemptedAssets"] ==
            logExist.data.data[0]["outcome"]["totalAssets"])
      ) {
        response = await insertSummaryLog(data);
      } else {
        let lastRecord = maxBy(logExist?.data?.data, "id");
        console.log(":LLSLSL", lastRecord);
        response = await updateSummaryLog(
          lastRecord.id,
          { outcome: data.outcome },
          data.actor,
          data.target,
          data.site_uuid
        );
      }

      resolve({
        status: 200,
        message: "Summary Upserted",
        data: response,
      });
    } catch (error) {
      resolve(error);
    }
  });
};

export const dropSummaryLog = async (
  assets,
  assignmentId,
  userInfo,
  selfLearn = false
) => {
  return new Promise(async (resolve, reject) => {
    try {
      let allAssetsData = await getAllAssets(assets);
      allAssetsData = allAssetsData.data;
      let mainObj = {
        totalAssets: allAssetsData.length,
        attemptedAssets: 0,
        score: 0,
        totalTimeSpent: 0,
        skillwise: [],
        summary: [],
      };

      allAssetsData.forEach((val, index) => {
        let content = JSON.parse(val.content);
        mainObj["summary"].push({
          assetId: val.asset_uid,
          score: 0,
          duration: 0,
          logId: null,
          skills: content?.content?.info?.skills,
          difficultyLevel: content?.content?.info?.difficulty_level,
          assetTypeAlias: content?.content?.info?.asset_type_alias,
          assetSubtype: content?.content?.info?.asset_subtype,
        });

        content?.content?.info?.skills.map((val1, index1) => {
          let pos = findIndex(mainObj["skillwise"], (o) => {
            return o && o.name == val1;
          });
          if (pos > -1) {
            mainObj["skillwise"][pos]["totalAssets"] += 1;
          } else {
            mainObj["skillwise"].push({
              name: val1,
              score: 0,
              totalAssets: 1,
            });
          }
        });

        if (
          !content?.content?.info?.skills ||
          content?.content?.info?.skills?.length == 0
        ) {
          let pos1 = findIndex(mainObj["skillwise"], (o) => {
            return o && o.name == "peripheral";
          });
          if (pos1 > -1) {
            mainObj["skillwise"][pos1]["totalAssets"] += 1;
          } else {
            mainObj["skillwise"].push({
              name: "peripheral",
              score: 0,
              totalAssets: 1,
            });
          }
        }
      });

      let response = await UpsertSummaryLog({
        actor: userInfo.uid,
        verb: "assignmentSummary",
        target: assignmentId,
        outcome: mainObj,
        site_uuid: userInfo.site_uuid,
        selfLearn: selfLearn,
      });

      resolve({
        status: 200,
        message: "Drop Summary",
        data: response,
      });
    } catch (error) {
      resolve(error);
    }
  });
};

export const getSpecialAssessmentLog = async (actor, site_uuid) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("user-logs").find({
        query: {
          verb: "specialExamLog",
          actor: actor,
          site_uuid: site_uuid,
          $sort: {
            created_at: -1,
          },
        },
      });

      resolve({
        status: 200,
        message: "Summary Logs",
        data: response,
      });
    } catch (error) {
      resolve(error);
    }
  });
};
